import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import IconButton from '../../../IconButton/IconButton.js';
import { useDrawer } from '../../context/DrawerContext.js';

const DrawerCloseButton = ()=>{
    const { getLabel  } = useIntl();
    const { close  } = useDrawer();
    return /*#__PURE__*/ React.createElement(IconButton, {
        variant: "ghost",
        "aria-label": getLabel('common.actions.close'),
        "data-t": "drawer-close",
        onClick: close
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "close"
    }));
};

export { DrawerCloseButton };
//# sourceMappingURL=DrawerCloseButton.js.map
